import wx from 'weixin-js-sdk'
const axios = require('axios');
 
export default function getLocation() {
    return new Promise(resove => {
        axios.get('https://zhwy.zjj.suqian.gov.cn/api/wechat/wxConfig', { // 这是请求后台的地址
            params:{
                url: window.location.href.split('#')[0]
            }    
        })
        .then(function(res) {
            const data = res.data.data //返回wx.config需要的参数
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见官网附录1
                jsApiList:['getLocation'],
                openTagList: ['wx-open-launch-weapp']
            })
            wx.ready(function() {
                wx.getLocation({
                    type: "gcj02", //默认是wgs84,gps坐标，gcj02是高德
                    success: function (res) {
                    var lat = res.latitude;
                    var lng = res.longitude;
                    resove({
                        lat:res.latitude,
                        lng:res.longitude
                    });                    },
                    fail(err) {
                        console.log(err);
                    }
                })
            })
            wx.error(function(res) {
                console.log(res)
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            })
        })
        .catch(function(error) {
            console.log(error)
        })
    })

  
}